module.exports = __webpack_public_path__ + "img/sm.eb21fa05.svg";